module.exports = __webpack_public_path__ + "img/dj_left_rect.15fa2bf1.png";